import React, { Component } from "react";
import STable from "../../../components/Common/STable";
// import Checkbox from "../../../components/Common/checkbox";
import NumberFormat from "react-number-format";

var base64 = require("base-64");

class RekapQcGroupTable extends Component {
  columns = [
    // {
    //   path: "selected",
    //   label: " ",
    //   content: (item, index) => (
    //     <Checkbox
    //       onChange={() => this.props.handleCheckPrint(item, index)}
    //       isChecked={item.selected}
    //       id={`${index}Selected`}
    //     />
    //   )
    // },
    {
      path: "idx",
      label: "#",
      content: (item, index, currentPage, limit) => (
        <span>{index + 1 + limit * (currentPage - 1)}</span>
      ),
    },
    {
      path: "stuffing_date",
      label: "Tanggal Stuffing",
    },
    {
      path: "group",
      label: "Group",
    },
    {
      path: "qc_dimension",
      label: "Dimension",
      content: (item, index) => (
        <NumberFormat
          onClick={()=>this.props.gotoDimension(item)}
          style={{textDecoration: 'underline', cursor: item.qc_dimension>0?'pointer':''}}
          value={item.qc_dimension}
          displayType={"text"}
          thousandSeparator={true}
        />
      ),
    },
    // {
    //   path: "qc_surface",
    //   label: "Surface",
    //   content: (item, index) => (
    //     <NumberFormat
    //       onClick={()=>this.props.gotoSurface(item)}
    //       style={{textDecoration: 'underline', cursor: item.qc_surface>0?'pointer':''}}
    //       value={item.qc_surface}
    //       displayType={"text"}
    //       thousandSeparator={true}
    //     />
    //   ),
    // },
    // {
    //   path: "qc_stuffing",
    //   label: "Stuffing",
    //   content: (item, index) => (
    //     <NumberFormat
    //       onClick={()=>this.props.gotoStuffing(item)}
    //       style={{textDecoration: 'underline', cursor: item.qc_stuffing>0?'pointer':''}}
    //       value={item.qc_stuffing}
    //       displayType={"text"}
    //       thousandSeparator={true}
    //     />
    //   ),
    // },
  ];
  hideAction = (column) => {
    let col = column.filter(function (obj) {
      return obj.label !== "Status" && obj.path !== "is_under_hjm";
    });
    return col;
  };
  render() {
    const { items, from, sortColumn, onSort, ...rest } = this.props;
    return (
      <STable
        columns={this.columns}
        data={items}
        sortColumn={sortColumn}
        onSort={onSort}
        {...rest}
        keyId="id_qc_group_item"
      />
    );
  }
}

export default RekapQcGroupTable;



// WEBPACK FOOTER //
// ./src/views/qc/report/rekapQcGroupTable.jsx